<template>
   <div class="searchform-box"  style="position:relative">
    <div class="searchform-title" @click="open = !open">
      查询条件
      <img class="searchform-title-icon" :class="open?'open':''" src="@/assets/images/buttonIcon/ic_searcharrow.png"/>
    </div>
    <!--项目信息页面才展示-->
    <div class="toggleBox" v-if="name === 'ProjiectInforList'">
        <span class="active" @click="handleToggle(true)"><img src="@/assets/images/listIcon.png" alt=""><img class="activeImg" src="@/assets/images/listIconActive.png" alt=""></span>
        <span @click="handleToggle(false)"><img src="@/assets/images/cardIcon.png" alt=""><img class="activeImg" src="@/assets/images/cardIconActive.png" alt=""></span>
    </div>
    <transition name='searchform' duration="300">
      <div class="searchform-content" v-if="open">
        <slot></slot>
        <div class="searchform-btn">
          <el-button type="primary" @click="handleSearch">
            <img class="btn-icon" src="@/assets/images/buttonIcon/btn_search.png"/>
            查 询
          </el-button>
          <el-button @click='handleResetSearchForm'>
            <img class="btn-icon" src="@/assets/images/buttonIcon/btn_refresh.png"/>
            重 置
          </el-button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'searchForm',
  components: {},
  props: {
    form: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      open: true,
      name: '',
      defaultForm: {}
    }
  },
  created () {
    this.defaultForm = {...this.form}
    console.log(this.$route)
    this.name = this.$route.name
  },
  methods: {
    handleToggle (val) {
      if (!val) {
        window.sessionStorage.removeItem('ProjiectInforList')
        this.$router.push({name: 'ProjiectInformation'})
      }
    },
    handleSearch () {
      this.$emit('search', true)
    },
    handleResetSearchForm () {
      this.$emit('update:form', {...this.defaultForm})
      this.$emit('resetForm')
    }
  }
}
</script>
<style lang='less'>
.searchform{
  &-box{
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(213, 213, 213, .5);
    margin-bottom: 18px;
  }
  &-title{
    font-size: 16px;
    font-weight: bold;
    line-height: 26px;
    padding: 8px 16px;
    border-bottom: 1px solid #e8e8e8;
    cursor: pointer;
    &-icon{
      width: 14px;
      height: 14px;
      display: inline-block;
      vertical-align: middle;
      transition: transform linear .3s;
      &.open{
        transform: rotate(-180deg);
      }
    }
  }
  &-content{
    padding: 16px;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    height: auto;
    transition: height linear .3s,padding linear .3s;
    &.searchform-enter-to{
      padding-top: 16px;
      padding-bottom: 16px;
      height: 100px
    }
    &.searchform-leave-to{
      padding: 0 16px;
      height: 0;
    }
    &.searchform-enter{
      padding: 0 16px;
      height: 0px;
    }
    &.searchform-leave{
      padding: 0 16px;
      height: 0;
    }
    &.is-close{
      height: 0;
    }
    .search-form{
      flex: 1;
    }
  }
  &-btn{
    min-width: 190px;
    line-height: 40px;
  }
}
</style>
<style lang='less' scoped>
.toggleBox{
        position: absolute;
        top:10px;
        right: 16px;
        cursor: pointer;
        span{
            .activeImg{
                display: none;
            }
            &.active{
                img{display: none;}
                .activeImg{
                    display: inline-block;
                }
            }
        }
        img{
            width: 16px;
        }
    }
  </style>



// WEBPACK FOOTER //
// src/area-base/components/common/SearchForm.vue